export function Loading({ message = "Loading..." }: { readonly message?: string }) {
  return (
    <div className="flex items-center justify-center h-screen">
      <p className="body-regular" style={{ color: "var(--color-text-300)" }}>{message}</p>
    </div>
  );
}
